import React, { useState } from "react";
import Header from "../layout/headerHome";
import ClinicLocator from "../element/component/ClinicLocator/ClinicLocator";
import { clinics } from "../../data/clinicData";
import Counter from "../element/component/Counter";


const services = [
  {
    image: "/images/new-website/physiotherapy/physiotherapist.webp",
    color: "#f0f8e8",
    name: "Doctor Consultations",
    bgImage: "/images/new-website/clinics/stetoscope.webp",
  },
  {
    image: "/images/sugar-blood-test.webp",
    color: "#f0f8e8",
    name: "Diagnostics & Lab",
    bgImage: "/images/new-website/clinics/microscope.webp",
  },
  {
    image: "/images/new-website/dental/dental-implants.webp",
    color: "#f0f8e8",
    name: "Pharmacy",
    bgImage: "/images/new-website/clinics/clean-tooth.webp",
  },
  {
    image: "/images/new-website/physiotherapy/back-neuro.webp",
    color: "#f0f8e8",
    name: "Physiotherapy",
    bgImage: "/images/new-website/clinics/physiotherapy-clinics.webp",
  },
  {
    image: "/images/new-website/dental/dental-implants.webp",
    color: "#f0f8e8",
    name: "Dental care",
    bgImage: "/images/new-website/clinics/clean-tooth.webp",
  },
  {
    image: "/images/new-website/clinics/eye-exam.webp",
    color: "#f0f8e8",
    name: "Eye & Hearing Care",
    bgImage: "/images/new-website/clinics/eye-checkup.webp",
  },
  {
    image: "/images/new-website/clinics/eye-exam.webp",
    color: "#f0f8e8",
    name: "Diet & Nutrition",
    bgImage: "/images/new-website/clinics/eye-checkup.webp",
  },
  {
    image: "/images/women-care-1.webp",
    color: "#f0f8e8",
    name: "Yoga & Fitness",
    bgImage: "/images/new-website/clinics/preventive-health.webp",
  },
  {
    image: "/images/new-website/clinics/syringe.webp",
    color: "#f0f8e8",
    name: "Vaccinations",
    bgImage: "/images/new-website/clinics/vaccination.webp",
  },
    {
    image: "/images/new-website/clinics/syringe.webp",
    color: "#f0f8e8",
    name: "Nursing Care",
    bgImage: "/images/new-website/clinics/vaccination.webp",
  },
    {
    image: "/images/new-website/yoga/brain-health.webp",
    color: "#f0f8e8",
    name: "Women's Health",
    bgImage: "/images/new-website/clinics/inner-peace.webp",
  },
  {
    image: "/images/women-care-1.webp",
    color: "#f0f8e8",
    name: "Preventive health",
    bgImage: "/images/new-website/clinics/preventive-health.webp",
  },
  {
    image: "/images/new-website/clinics/syringe.webp",
    color: "#f0f8e8",
    name: "Diabetes & Metabolic Care",
    bgImage: "/images/new-website/clinics/vaccination.webp",
  },
  {
    image: "/images/new-website/clinics/syringe.webp",
    color: "#f0f8e8",
    name: "L1 Emergency Services",
    bgImage: "/images/new-website/clinics/vaccination.webp",
  },
];

const testimonials = [
  { stars: 4, text: "Booked an appointment in 2 minutes, no waiting. The doctor was thorough and the lab results came by evening.",                              name: "Priya M.",  role: "Patient · Indiranagar" },
  { stars: 4, text: "We set up a Bridge Health clinic inside our 1,200-person office. Absenteeism dropped noticeably in the first quarter.",                     name: "Rahul S.", role: "HR Director · Tech company" },
  { stars: 4, text: "The preventive health packages are excellent value. Our residents use the clinic almost like a family doctor.",                              name: "Deepa K.", role: "RWA President · Whitefield" },
];

export default function BridgeHealth() {
  const [activeClinic, setActiveClinic] = useState(0);
  const [searchVal, setSearchVal]       = useState("");

const filteredClinics = clinics.filter((clinic) => {
  const keyword = searchVal.toLowerCase();

  return (
    clinic?.name?.toLowerCase()?.includes(keyword) ||
    clinic?.area?.toLowerCase()?.includes(keyword) ||
    clinic?.address?.toLowerCase()?.includes(keyword) ||
    clinic?.pincode?.includes(keyword) ||
    clinic?.services?.some(
      (service) =>
        service &&
        service.toLowerCase().includes(keyword)
    )
  );
});

  return (
    
    <div className="bh-root">
      <Header />
      {/* ── NAV ── */}
      {/* <nav className="bh-nav">
        <img src="/images/new-website/bhlogo.webp"></img>
        <ul className="bh-nav-links">
          {["Clinics", "Services", "Health Plans", "For Organizations", "About"].map((l) => (
            <li key={l}><a href="#">{l}</a></li>
          ))}
        </ul>
        <div className="bh-nav-actions">
          <button className="bh-nav-btn-signin">Sign in</button>
          <button className="bh-nav-btn-book">Book now</button>
        </div>
      </nav> */}

      {/* ── HERO ── */}
     <section className="clinic-hero">
      <div className="clinic-hero__content">
        <h1 className="clinic-hero__title">
          Healthcare,
          <br />
          Closer to You
        </h1>

        <p className="clinic-hero-description">
          Bridge Health clinics bring trusted medical care,
          diagnostics and wellness services closer to where
          you live and work.
        </p>

        <div className="clinic-hero__features">
          <div className="clinic-hero__feature">
            <div className="clinic-hero-icon-bg">
              <img src="/images/new-website/physiotherapy/physiotherapist.webp"></img>
            </div>
            <span>Trusted Doctors</span>
          </div>

          <div className="clinic-hero__feature">
            <div className="clinic-hero-icon-bg">
              <img src="/images/heart-checkup.webp"></img>
            </div>
            <span>Modern Clinics</span>
          </div>

          <div className="clinic-hero__feature">
            <div className="clinic-hero-icon-bg">
              <img src="images/new-website/home-new/healthcare-home.webp"></img>
            </div>
            <span>Complete Care</span>
          </div>
        </div>

        <div className="clinic-hero__buttons">
          <button className="clinic-hero__btn clinic-hero__btn--primary">
            Find a Clinic Near You
          </button>

          <button className="clinic-hero__btn clinic-hero__btn--secondary">
            Build a Clinic With Us
          </button>
        </div>
      </div>

      <div className="clinic-hero__image-wrapper">
        <img
          src="/images/new-website/clinics/bh-clinic-banner.webp"
          alt="Bridge Health"
          className="clinic-hero__image"
        />
      </div>
    </section>
    
    {/* — CLINICS — */}

      <section className="clinic-locator-section">

        <div className="clinic-locator-header">
          <div className="services-badge">
              <span className="services-badge-icon">❤</span>
              <span>CLINICS NEAR YOU</span>
            </div>
          <h2>Find a Bridge Health Clinic Near You</h2>
          <p>
            Explore our clinics across Bengaluru.
            Search by area, pincode or services.
          </p>
        </div>
        <div className="clinic-locator-layout">

  {/* LEFT SIDE MAP */}
  <div className="clinic-map-container">
    <ClinicLocator clinics={filteredClinics} />
  </div>

  {/* RIGHT SIDE PANEL */}
  <div className="clinic-right-panel">

    {/* TOOLBAR */}
    <div className="clinic-locator-toolbar">

      <div className="clinic-search-box">
        <input
          type="text"
          placeholder="Search by area, landmark or pincode..."
          value={searchVal}
          onChange={(e) => setSearchVal(e.target.value)}
        />
      </div>

      <button className="clinic-filter-btn">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <line x1="4" y1="6" x2="20" y2="6" />
          <circle cx="9" cy="6" r="2" />
          <line x1="4" y1="12" x2="20" y2="12" />
          <circle cx="15" cy="12" r="2" />
          <line x1="4" y1="18" x2="20" y2="18" />
          <circle cx="11" cy="18" r="2" />
        </svg>

        Filter by service
      </button>

      <button className="clinic-nearme-btn">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <circle cx="12" cy="12" r="8" />
          <circle cx="12" cy="12" r="2" />
        </svg>

        Near me
      </button>

    </div>

    {/* CLINIC LIST */}
    <div className="clinic-list-container">

      {filteredClinics.map((clinic) => (
        <div
          className="clinic-list-card"
          key={clinic.id}
        >
          <div className="clinic-list-header">

            <div className="clinic-list-info">
              <h4>{clinic.name}</h4>
              <p>{clinic.address}</p>
            </div>

            <div className="clinic-list-status">
              <span>Open</span><br/>
              <small>7 AM - 9 PM</small>
            </div>

          </div>

          <div className="clinic-card-actions">
            <button className="clinic-action-btn">
              <img src="/images/new-website/clinics/location-clinic.webp"></img>
              <span>Directions</span>
            </button>

            <button className="clinic-action-btn">
              <img src="/images/new-website/clinics/phone-call-clinic.webp"></img>
              <span>Call</span>
            </button>
          </div>
        </div>
      ))}

      <div className="clinic-view-all">
        View all clinics →
      </div>

    </div>

    </div>

    </div>

      </section>

      {/* ── SERVICES ── */}
      <section className="bh-services">
        <div className="bh-services-inner">
            <section className="services-heading">
            <div className="services-badge">
              <span className="services-badge-icon">❤</span>
              <span>OUR SERVICES</span>
            </div>

            <h2 className="services-title">
              Comprehensive care for every need
            </h2>

            <p className="services-subtitle">
              Expert care across a wide range of medical services for you and your family.
            </p>
        </section>
          <div className="bh-services-grid">
            {
            services.map((service, index) => (
              <div key={index} className="bh-service-card">
                <div
                  className="clinic-hero-icon"

                >
                  <img src={service.image} alt={service.name} />
                </div>

                <h3>{service.name}</h3>

              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <div className="bh-stats">
        {[
          {
            end: 8,
            suffix: "",
            label: "Clinics in Bengaluru",
          },
          {
            end: 50000,
            suffix: "+",
            label: "Patients served",
          },
          {
            end: 120,
            suffix: "+",
            label: "Doctors & specialists",
          },
          {
            end: 4.8,
            suffix: "★",
            label: "Average patient rating",
            decimals: 1,
          },
          {
            end: 30,
            suffix: "+",
            label: "Corporate partners",
          },
        ].map((s) => (
          <div className="bh-stats-item" key={s.label}>
            <div className="bh-stats-number">
              <Counter
                end={s.end}
                suffix={s.suffix}
                decimals={s.decimals || 0}
                duration={2000}
              />
            </div>

            <div className="bh-stats-label">
              {s.label}
            </div>
          </div>
        ))}
      </div>


      {/* ── ORGS ── */}
      <section className="bh-orgs">
        <div className="bh-orgs-inner">
          <div>
            <div className="services-badge">
              <span className="services-badge-icon">❤</span>
              <span>FOR ORGANIZATIONS</span>
            </div>
            <h2 className="bh-orgs-title">Bring a Bridge Health clinic to your campus or community</h2>
            <p className="clinic-hero-description">
              We partner with corporates, residential complexes, SEZs, and institutions to set up
              fully-managed, on-site health clinics. Your employees or residents get primary care,
              diagnostics, and wellness services — without leaving the premises.
            </p>
            <ul className="bh-orgs-features">
              {[
                "Ideal for offices, tech parks, factories & co-working spaces",
                "Residential complexes, gated communities & townships",
                "End-to-end setup – equipment, staff, tech & operations",
                "Real-time health analytics & utilisation reports",
                "NABH-aligned quality standards",
              ].map((f) => (
                <li key={f}>
                  <img
                    src="/images/new-website/clinics/check-mark.webp"
                    alt=""
                    className="bh-orgs-feature-icon"
                  />
                  <span>{f}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="bh-orgs-enquiry-card">
            <div className="bh-orgs-enquiry-title">Enquire about opening a clinic</div>
            <div className="bh-orgs-form-row">
              <div className="bh-orgs-form-group bh-input-icon">
                <img
                  src="/images/new-website/clinics/user-clinic.webp"
                  alt="User"
                  className="bh-input-icon-img"
                />
                <input placeholder="Your name" />
              </div>

              <div className="bh-orgs-form-group bh-input-icon">
                <img
                  src="/images/new-website/clinics/office-clinic.webp"
                  alt="Company"
                  className="bh-input-icon-img"
                />
                <input placeholder="Company / Society" />
              </div>
            </div>
            <div>
              <div className="bh-orgs-form-group bh-input-icon">
                <img
                  src="/images/new-website/clinics/phone-call-clinic.webp"
                  alt="Phone"
                  className="bh-input-icon-img"
                />
                <input placeholder="Phone Number" />
              </div>
            </div>
            <div className="bh-orgs-form-group">
                <label>Organisation type</label>
                <select>
                  <option>Select type</option>
                  <option>Corporate</option>
                  <option>Residential</option>
                  <option>Educational</option>
                  <option>Healthcare</option>
                </select>
            </div>
            <div className="bh-orgs-form-group">
              <label>Approximate employee / resident count</label>
              <select>
                <option>Select range</option>
                <option>Under 100</option>
                <option>100 – 500</option>
                <option>500 – 1,000</option>
                <option>1,000 – 5,000</option>
                <option>5,000+</option>
              </select>
            </div>
            <div className="bh-orgs-form-group">
            <label>Tell us more (optional)</label>
            <div className="bh-orgs-form-group">
              <textarea placeholder="Location, specific services needed, timeline…" />
            </div>
            </div>
            <button className="bh-orgs-form-submit">Request a callback</button>
          </div>
        </div>
      </section>

 
      {/* ── TESTIMONIALS ── */}
      <section className="bh-testimonials">
            <div className="services-badge">
              <span className="services-badge-icon">❤</span>
              <span>WHAT PEOPLE SAY</span>
            </div>
        <h2 className="bh-section-title">Trusted by patients &amp; partners</h2>
        <div className="bh-testimonials-grid">
          {testimonials.map((t) => (
            <div className="bh-testimonials-card" key={t.name}>
              <div className="bh-testimonials-stars">{"★".repeat(t.stars)}{"☆".repeat(5 - t.stars)}</div>
              <p className="bh-testimonials-text">"{t.text}"</p>
              <div className="bh-testimonials-author">{t.name}</div>
              <div className="bh-testimonials-role">{t.role}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="bh-footer">
        <div className="bh-footer-inner">
          <div className="bh-footer-grid">
            <div>
              <img src="/images/new-website/clinics/BH-logo-white.webp" width="50%"></img>
              <p className="bh-footer-tagline">
                Primary care &amp; diagnostics across Bengaluru.<br />
                Accessible, affordable, accountable.
              </p>
            </div>
            <div>
              <div className="bh-footer-col-title">Clinics</div>
              <ul className="bh-footer-links">
                {["Indiranagar", "Koramangala", "Whitefield", "HSR Layout", "+ 4 more"].map((l) => (
                  <li key={l}><a href="#">{l}</a></li>
                ))}
              </ul>
            </div>
            <div>
              <div className="bh-footer-col-title">Services</div>
              <ul className="bh-footer-links">
                {["General physician", "Diagnostics", "Dental", "Mental wellness"].map((l) => (
                  <li key={l}><a href="#">{l}</a></li>
                ))}
              </ul>
            </div>
            <div>
              <div className="bh-footer-col-title">Organizations</div>
              <ul className="bh-footer-links">
                {["Open a clinic", "Corporate health", "Residential", "Contact us"].map((l) => (
                  <li key={l}><a href="#">{l}</a></li>
                ))}
              </ul>
            </div>
          </div>
          <div className="bh-footer-bottom">
            <div className="bh-footer-bottom-copy">©2025 Bridge Health. All rights reserved.</div>
            <div className="bh-footer-bottom-links">
              <a href="#">Privacy policy</a>
              <a href="#">Terms of use</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}